import { all, call } from "redux-saga/effects";
import onCreateSection from "./createSection";
import onCreateSectionMedia from "./createSectionMedia";
import onDeleteSection from "./deleteSection";
import onEditSection from "./editSection";
import onEditSectionMedia from "./editSectionMedia";
import onGetAllSection from "./getAllSection";
import onGetSection from "./getSection";

export default function* sectionSagas() {
  yield all([
    call(onCreateSection),
    call(onGetAllSection),
    call(onDeleteSection),
    call(onGetSection),
    call(onEditSection),
    call(onCreateSectionMedia),
    call(onEditSectionMedia),
  ]);
}
